<script lang="ts">
  import axios from 'axios'
  import { onMount } from 'svelte'
  import globalStore from '@/stores/global.svelte'
  import Modal from '../../shared/modals/Modal.svelte'

  let {
    showing = false,
    onClose = () => {},
    contactImport = null,
  } = $props()

  let show = $state(false)

  onMount(() => {
    show = showing
  })

  let currentAccount = $derived(globalStore.currentAccount)
  let creditsRemaining = $derived(Number(currentAccount.credits))
  let estimatedContactCount = $derived(Number(contactImport.meta.estimated_contact_count))
  let insufficientCredits = $derived(creditsRemaining < estimatedContactCount)

  $effect(() => {
    show = showing
  })

  function restart() {
    axios
      .post(`/contact_imports/${contactImport.to_param}/retry`)
      .then(response => {
        toastr.info('Retrying! This import will restart in about 10 seconds.')
        show = false
      })
      .catch(error => {
        toastr.error(error.response.data.errors)
      })
  }
</script>

<Modal id="retry-modal" {show} {onClose}>
  {#snippet title()}
    <strong>Retry Contact Import</strong>
  {/snippet}

  {#if contactImport}
    {#snippet content()}
      <div slot="content" class="text-center">

        <p>
          This import will cost up to
          <strong>{estimatedContactCount}</strong> credits.<sup>*</sup>
        </p>

        <p class="text-muted small">
          <sup>*</sup>(Each new contact = 1 required opt-in message = 1 credit.
          <br>
          Existing contacts do not have a credit cost during imports.)
        </p>

        {#if insufficientCredits}
          <div class="alert alert-info">
            <p>You only have {creditsRemaining} credits remaining in your account.</p>
            <p>
              Would you like to
              <a href="/refills/new">purchase additional credits?</a>
            </p>
          </div>
        {:else}
          <p class="mt-3">
            <button type="button" class="btn btn-primary" onclick={restart}>Restart this import</button>
          </p>
        {/if}

      </div>
    {/snippet}
  {/if}
</Modal>

<style lang="scss">
  :global {
    #retry-modal .modal-inner {
      max-width: 45%;
    }
  }
</style>
